import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { getItem, removeItem } from "../utils/localStorage";

function createApolloClient() {
  const hostname = process.env.REACT_APP_API_URL;

  const httpLink = createHttpLink({
    uri: `${hostname}/graphql`,
  });

  const authLink = setContext(async (_, { headers }) => {
    const tokenData = await getItem("token");
    return {
      headers: {
        ...headers,
        authorization: tokenData ? `Bearer ${tokenData?.token}` : "",
      },
    };
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    let isUnauthorized = false;

    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        const msg = err.message ? err.message.toLowerCase() : "";
        const code = err.extensions?.code;
        if (
          msg.includes("unauthorized") ||
          msg.includes("jwt expired") ||
          msg.includes("authorization is doubted") ||
          code === "UNAUTHENTICATED"
        ) {
          isUnauthorized = true;
          break;
        }
      }
    }

    if (networkError && "statusCode" in networkError && networkError.statusCode === 401) {
      isUnauthorized = true;
    }

    if (isUnauthorized) {
      if (!window.location.pathname.includes("/signin") && !window.location.pathname.includes("/signup")) {
        removeItem("token");
        window.location.href = "/signin";
      }
    }
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(errorLink).concat(httpLink),
  });
}

export const client = createApolloClient();
